'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1099 797.68",
    width: "1em",
    height: "1em",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("style", null, '.money-exchange_svg__a{fill:#f2f2f2}.money-exchange_svg__b{fill:#2f2e41}.money-exchange_svg__c{fill:#ffb9b9}.money-exchange_svg__d{opacity:.1}.money-exchange_svg__d,.money-exchange_svg__h{isolation:isolate}.money-exchange_svg__e{fill:#575a89}.money-exchange_svg__h{opacity:.2}.money-exchange_svg__g{fill:#1495f3}.money-exchange_svg__h,.money-exchange_svg__i{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px}.money-exchange_svg__i{stroke:#3f3d56}.money-exchange_svg__j{fill:#3f3d56}.money-exchange_svg__k{fill:#9f616a}.money-exchange_svg__l{fill:#d0cde1}.money-exchange_svg__m{fill:#16c68b}.money-exchange_svg__p{fill:#fff}')), /*#__PURE__*/React__namespace.createElement("circle", {
    className: "money-exchange_svg__a",
    cx: 471,
    cy: 373,
    r: 373
  }), /*#__PURE__*/React__namespace.createElement("ellipse", {
    className: "money-exchange_svg__a",
    cx: 148,
    cy: 774,
    rx: 148,
    ry: 23.68
  }), /*#__PURE__*/React__namespace.createElement("ellipse", {
    className: "money-exchange_svg__a",
    cx: 870,
    cy: 736.97,
    rx: 229,
    ry: 36.64
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__b",
    d: "M819.12 384.78s2 6.5-9.1 12.35-14.3 27.95-1.3 34.45 16.9 14.94 10.4 20.79-18.2 21.45-2.6 25.35 17.55 11.69 13 14.94 10.4-5.84 10.4-5.84 2.6 15.59 16.24 11.69 52-78 32.5-88.38-69.54-25.35-69.54-25.35Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__c",
    d: "M842.68 447.54s6.74 23.59-5.06 25.28a46.05 46.05 0 0 0-20.22 8.42l21.9 28.65h40.45L905 484.61s-33.7-25.28-27-40.44-35.32 3.37-35.32 3.37Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__d",
    d: "M842.68 447.54s6.74 23.59-5.06 25.28a46.05 46.05 0 0 0-20.22 8.42l21.9 28.65h40.45L905 484.61s-33.7-25.28-27-40.44-35.32 3.37-35.32 3.37Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__c",
    d: "m852.79 740.78 38.76 13.48 26.96 1.69-1.68-23.6-55.62-16.45-8.42 24.88z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__e",
    d: "M902.5 735.72s0 23.6 3.37 23.6 48.88-5.06 62.36 0 33.71-13.49 23.59-23.6-26.6-25.28-36.89-21.91-52.43 11.8-52.43 11.8ZM778.63 713.81s-20.22 40.45-6.74 43.82 28.65-1.68 30.34-3.37 25.28-8.43 28.65-5 3.37-13.49 3.37-13.49Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__b",
    d: "M795.49 658.2s-32 43.82-8.43 55.61 136.51 11.8 144.94 0 11.79-48.87 0-52.24-136.51-3.37-136.51-3.37Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M795.49 658.2s-32 43.82-8.43 55.61 136.51 11.8 144.94 0 11.79-48.87 0-52.24-136.51-3.37-136.51-3.37Z",
    style: {
      opacity: 0.2,
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React__namespace.createElement("circle", {
    className: "money-exchange_svg__c",
    cx: 856.16,
    cy: 420.57,
    r: 38.76
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__g",
    d: "m795.49 481.24 33.7-6.74s8.43 27 35.39 21.91 33.71-21.91 33.71-21.91 20.22 8.43 21.91 8.43 23.59 8.42 23.59 13.48S918.51 552 918.51 552l3.37 91-124.71-3.37 8.43-89.32Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__c",
    d: "M777 525.06s-10.11 89.32-3.37 96.06 33.7 25.28 33.7 25.28v-20.22L793.8 600.9l13.48-59ZM951.38 522.53s-5.9 91.85-5.9 95.22-15.17 15.17-20.23 15.17-8.42-8.43-8.42-8.43l11.8-13.49-8.43-69.1Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__b",
    d: "M935.37 651.46s75.83-42.13 77.52 0-38.76 59-38.76 59-104.49 31.34-108.7 19.88-12.64-30-5.9-31.67 15.17-5.06 18.54-1.69 45.5-25.28 45.5-25.28Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__h",
    d: "M970.76 646.4s-15.17 6.74-20.23 11.8-27 13.48-27 13.48"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__g",
    d: "m805.6 484.61-10.11-3.37s-37.08 38.76-25.28 48.88 18.54 13.48 21.91 16.88 20.22 5 20.22 5ZM928.63 493l15.16 3.37s11.8 25.28 15.17 28.65-5.06 1.69-10.11 8.43S938.74 552 928.63 552 905 535.17 905 535.17Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__b",
    d: "M798.86 666.63s-64-45.51-86-11.8 94.42 79.17 111.28 85.95 32 13.48 32 13.48 15.17-37.08 15.17-43.82-11.8-6.74-15.17-6.74-18.54-3.37-21.91-8.42-35.37-28.65-35.37-28.65Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__h",
    d: "M763.47 654.83s16.85 13.48 32 16.85 20.22 11.8 20.22 11.8"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__e",
    d: "m787.23 591.46 1.35 71.36a8.93 8.93 0 0 0 9 8.76l132.79-1.49a8.94 8.94 0 0 0 8.82-8.42l4-69.86a8.93 8.93 0 0 0-8.41-9.43H796.16a8.93 8.93 0 0 0-8.93 8.93Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__b",
    d: "M858.23 371.88s2.16 7.2-10.08 13.68-15.84 31-1.44 38.16 18.72 16.55 11.52 23-20.16 23.76-2.88 28.08 19.44 13 14.4 16.56 11.52-6.48 11.52-6.48 2.88 17.28 18 13 30.2-82.88 13.34-103.08c-15.67-18.8-54.38-22.92-54.38-22.92Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__b",
    d: "M853.63 364.47c0-10.55 31.56-3 45.09 11.76 9.37 10.2 23.6 25.54 11.67 36.35s20.44 25 29.12 29.29 25.82 17.45 10.34 26.26-15.22 17.72-9.4 19.83-12.84-3.13-12.84-3.13 1.89 17.41-13.83 17.33-60.84-86.49-50.06-110.51c10.02-22.34-10.09-27.18-10.09-27.18Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__b",
    d: "M860.46 362.16c-42.19-2.54-46.46 29.22-46.46 29.22.29 18.38 29.48 9.43 37.59 12.17 9.78-7 28.64-20.35 42.12-29.86a63.74 63.74 0 0 0-33.25-11.53Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__i",
    d: "M848.44 564.85s-37.85-177.4-274.77-306.09M139 246.89s34.91 148.35 253.44 256"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__j",
    d: "m583.43 254.89.47 1.95-9.58 2.32 3.02 9.39-1.91.61-3.67-11.44 11.67-2.83z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__g",
    d: "M68.47 746.11c0 22.47-13.35 30.32-29.83 30.32H37.5c-.77 0-1.52 0-2.27-.1-14.87-1-26.42-9.3-26.42-30.2 0-21.62 27.63-48.91 29.71-50.93l.12-.12s29.83 28.56 29.83 51.03Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__j",
    d: "m37.55 773 10.91-15.25-10.93 16.91v1.75c-.77 0-1.52 0-2.27-.1l1.18-22.48v-.18l.11-2.12-11-17 11 15.37v.45l.89-17-9.39-17.53 9.5 14.55.93-35.21-.16 27.76 9.35-11-9.38 13.4-.25 15.2L46.81 726 38 742.78l-.13 8.45 12.66-20.31-12.67 23.26Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__b",
    d: "m210.77 740.29 6.39-4.74s4.22 23.6-.49 27.13-22.4 9.43-22.4 16.5-40.06 16.5-41.24 5.89 3.53-16.5 3.53-16.5 18.86-18.85 21.22-22.39 8.25-10.6 8.25-10.6Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__b",
    d: "m116.5 446.85.48 2.94c.28 1.68.67 4.06 1.14 7 4.95 30.2 19.39 119.12 18.41 122.05-1.18 3.54-9.43 16.5 0 20 .91.34 1.89 1.44 2.93 3.19a68 68 0 0 1 5 11.76c5.62 16.31 11.63 42.41 15.11 60.49 1.52 7.94 2.55 14.33 2.86 17.68a9.56 9.56 0 0 1 0 2.33c-1.18 4.71 7.07 21.21 10.6 25.93s9.43 9.42 8.25 14.14 29.46 17.68 33 9.43 3.53-13 4.71-15.32 2.36-18.86-3.53-21.22-2.36-43.6-8.25-51.85c-2-2.74-5-12-8.12-23.23-1.24-4.38-2.49-9.05-3.71-13.73C190.43 599.31 186 580 186 580l1.17-137.88-64.81-8.25-1.66 3.67-3.31 7.27ZM113 673.12s-9.43-9.43-14.14 0-9.43 46-17.68 54.21-18.85 49.49-7.07 51.85 24.75-3.54 25.93-10.61 25.92-43.6 25.92-47.13-16.49-16.5-16.49-16.5Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__b",
    d: "M257.91 382s-15.32 137.88-18.85 150.84-22.39 62.46-28.29 70.71-43.6 75.42-48.31 79-14.15 13-14.15 13-17.67 17.68-20 21.21-22.39-7.07-23.57-14.14 1.18-18.86 2.36-23.57-2.36-11.78 1.18-15.32 21.21-21.21 21.21-29.46 30.64-56.57 42.42-67.17 9.43-28.29 9.43-28.29v-71.92l-64.81-20s3.53-56.56 11.78-56.56S245 371.43 257.91 382Z"
  }), /*#__PURE__*/React__namespace.createElement("circle", {
    className: "money-exchange_svg__k",
    cx: 162.46,
    cy: 146.35,
    r: 38.89
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__k",
    d: "M175.42 177s4.71 17.67 10.61 22.39-15.32 24.74-15.32 24.74l-40.07 2.36-7.07-22.39s13-25.93 9.42-42.42S175.42 177 175.42 177Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__g",
    d: "M191.92 197s-10.61 1.18-13 4.71-18.85 14.15-31.81 11.79-21.22-5.89-23.57-4.72-7.07 25.93-7.07 25.93l13 37.71-2.37 103.73-3.53 28.28s-7.07-9.43 21.21-3.54 64.81-4.71 76.6-5.89 31.82-4.71 33-11.78-3.54-33-3.54-33l-18.85-79-11.79-42.38Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__l",
    d: "M180.77 191.7s10-5.29 13.5-.57 48.32 11.78 48.32 15.32 9.43 99 7.07 107.24 4.72 17.67 4.72 17.67l8.25 35.36s22.39 67.17 13 69.53-17.68 0-21.21 0-2.36-44.78-11.79-56.57-22.39-41.24-24.75-47.14-31.88-87.2-30.68-96.63-6.43-44.21-6.43-44.21ZM131.82 197s-9.43 0-10.61 2.36-13 17.67-17.68 21.21S82.32 239.44 82.32 243s34.18 29.46 34.18 29.46 14.14 69.53 7.07 93.1-17.68 80.14-13 83.67 15.32 4.71 15.32 0 7.07-55.39 13-66 23.57-77.78 16.5-96.64S131.82 197 131.82 197Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__k",
    d: "M287.37 313.69s1.18 36.53-11.78 55.39-21.21 40.06-21.21 40.06-21.22-5.89-24.75-13-25.93-1.14-25.93-3.5 27.11-14.14 29.46-16.49 10.61-2.36 15.32-7.07 5.9-15.32 5.9-15.32l4.71-30.64Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__b",
    d: "M189.24 122.37c3-.27 6.08-.57 8.72-2 5.93-3.19 7.5-12.29 3-17.29a22.82 22.82 0 0 0-4.14-3.33l-9-6.1c-4-2.69-8-5.44-12.64-6.71-4.18-1.15-8.59-1-12.92-.76-8.4.52-16.85 1.6-24.75 4.5s-15.27 7.75-20 14.67c-7.59 11-7.69 25.78-3.51 38.45s12.11 23.7 19.93 34.51l4.05-19.8c.37-1.76.83-3.69 2.3-4.74 3.64-2.59 8.1 2.74 12.58 2.7 2.87 0 5.28-2.39 6.37-5.05s1.16-5.6 1.41-8.46c.54-6.07 2.66-14.51 8.4-17.85 5.33-3.11 14.19-2.2 20.2-2.74Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__d",
    d: "M187.06 447.8s-4 115.13-6.34 118.67 0-119 0-119Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__l",
    d: "M233.16 206.45h9.43s40.07 54.21 35.36 57.74 0 13 0 13l9.42 17.67s11.79 10.61 8.25 13-8.25 11.78-8.25 11.78-23.57-3.64-30.64 10.55l-15.28-19.3Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__b",
    d: "m204.155 237.227 32.35-13.36 24.896 60.282-32.35 13.36z"
  }), /*#__PURE__*/React__namespace.createElement("ellipse", {
    className: "money-exchange_svg__g",
    cx: 230.25,
    cy: 253.3,
    rx: 7,
    ry: 6.43,
    transform: "rotate(-22.44 230.227 253.285)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__k",
    d: "M209.59 300.72s-84.84 70.71-99 48.32 15.32-41.24 15.32-41.24 25.93 1.17 55.39-17.68l29.46-13s26.9-38.4 36.06-23.78-15.63 40.11-37.23 47.38Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__l",
    d: "m95.28 238.27-13 4.71v35.35l-4.71 7.07s1.18 14.15 4.71 17.68 10.61 2.36 8.25 10.61a44.55 44.55 0 0 0-1.18 16.5s21.21 27.1 22.39 23.57 17.68-47.14 20-47.14-23.57-68.35-23.57-68.35Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__b",
    d: "M250.25 416.8s12.19-11.78 6.09-12.37S229 392.06 225.5 398s24.75 18.8 24.75 18.8Z"
  }), /*#__PURE__*/React__namespace.createElement("ellipse", {
    className: "money-exchange_svg__m",
    cx: 482,
    cy: 183,
    rx: 17,
    ry: 9
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__i",
    d: "M547 213q-57.49-21.72-115 0v-47a199 199 0 0 1 115 0Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__i",
    d: "M531 203.28q-41.5-15.67-83 0v-33.92a143.6 143.6 0 0 1 83 0Z"
  }), /*#__PURE__*/React__namespace.createElement("ellipse", {
    className: "money-exchange_svg__i",
    cx: 488,
    cy: 179,
    rx: 17,
    ry: 9
  }), /*#__PURE__*/React__namespace.createElement("ellipse", {
    className: "money-exchange_svg__m",
    cx: 492.7,
    cy: 239.55,
    rx: 17,
    ry: 9,
    transform: "rotate(-11.54 492.518 239.468)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__i",
    d: "M562.39 255.94q-60.69-9.78-112.68 23l-9.4-46.05a199 199 0 0 1 112.68-23Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__i",
    d: "M544.77 249.62q-43.8-7.06-81.33 16.6L456.66 233A143.58 143.58 0 0 1 538 216.38Z"
  }), /*#__PURE__*/React__namespace.createElement("ellipse", {
    cx: 497.78,
    cy: 234.43,
    rx: 17,
    ry: 9,
    transform: "rotate(-11.54 497.586 234.332)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: '#3f3d56',
      fill: 'none'
    }
  }), /*#__PURE__*/React__namespace.createElement("ellipse", {
    className: "money-exchange_svg__m",
    cx: 489.17,
    cy: 295.49,
    rx: 9,
    ry: 17,
    transform: "rotate(-86.02 489.17 295.49)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__i",
    d: "M551.94 329.92q-55.86-25.65-114.73-8l3.27-46.88a199 199 0 0 1 114.72 8Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__i",
    d: "M536.65 319.12q-40.32-18.53-82.8-5.76l2.35-33.84a143.6 143.6 0 0 1 82.8 5.76Z"
  }), /*#__PURE__*/React__namespace.createElement("ellipse", {
    cx: 495.44,
    cy: 291.91,
    rx: 9,
    ry: 17,
    transform: "rotate(-86.02 495.435 291.911)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: '#3f3d56',
      fill: 'none'
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__i",
    d: "M414.92 214.09s-73.49-10.05-126 20.71"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__j",
    d: "m290.71 224.46 1.91.6-2.99 9.4 9.6 2.29-.47 1.95-11.68-2.79 3.63-11.45zM532.44 455.29h14.79v51.2h-14.79z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__j",
    d: "m557 496.87-35.98-42.81-72.21.67L405 497.39l.88.57h-.31v88.76H556.9v-88.76l.1-1.09z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__g",
    d: "m521.06 454.16-44.94 52.69v79.87h80.78v-89.9l-35.84-42.66z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__j",
    d: "M508.54 542.55h16.5v14.58h-16.5zM508.54 517.31h16.5v14.35h-16.5z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__p",
    d: "M508.54 542.55h16.5v14.58h-16.5zM508.54 517.31h16.5v14.35h-16.5z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__j",
    d: "M435.22 538.68h16.5v14.58h-16.5zM435.22 513.44h16.5v14.35h-16.5z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__p",
    d: "M435.22 538.68h16.5v14.58h-16.5zM435.22 513.44h16.5v14.35h-16.5z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__j",
    d: "m382.73 508.39-.81-1.83 9.03-3.96-4.6-8.72 1.77-.93 5.61 10.62-11 4.82z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__i",
    d: "M596 547.54s73.5 10.05 126-20.7"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "money-exchange_svg__j",
    d: "m720.21 537.17-1.91-.6 2.98-9.4-9.59-2.29.46-1.95 11.69 2.79-3.63 11.45z"
  }));
});
var MoneyExchange = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.MoneyExchange = MoneyExchange;